export const DATE_FORMAT = 'D.M.YYYY';

// Klíč pseudo-pokoje v `rooms`, kterým se reprezentuje rezervace pouze kalendářové události bez ubytování
export const WITHOUT_ACCOMMODATION_ROOM_ID = 'WITHOUT_ACCOMMODATION';

export const PAYMENT_METHOD_WITHOUT_PAYMENT = 'WITHOUT_PAYMENT';

export const TAB_OCCUPATIONS = 'OCCUPATIONS';
export const TAB_ROOMS = 'ROOMS';

export const TAB_OCCUPATIONS_DAYS = 24;


// WEBPACK FOOTER //
// ./src/constants.js